import * as React from 'react'
import FlexView from '@/modules/shared/components/FlexView'

type TitledValueProps = {
  title: string
  text: string
}
type TitledValueState = {}

export class TitledValue extends React.Component<
  TitledValueProps,
  TitledValueState
> {
  constructor(props: TitledValueProps) {
    super(props)
  }

  render() {
    const { title, text } = this.props
    return (
      <FlexView column hAlignContent="left" vAlignContent="center">
        <span className="label-small-2">{title}</span>
        <div className="label-2">{text}</div>
      </FlexView>
    )
  }
}
